/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.ori.telecomms.proto.VehicleStatus', null, global);
goog.exportSymbol('proto.ori.telecomms.proto.VehicleStatus.DriveMode', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ori.telecomms.proto.VehicleStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.ori.telecomms.proto.VehicleStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.ori.telecomms.proto.VehicleStatus.displayName = 'proto.ori.telecomms.proto.VehicleStatus';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ori.telecomms.proto.VehicleStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.ori.telecomms.proto.VehicleStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ori.telecomms.proto.VehicleStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.VehicleStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
    steering: +jspb.Message.getFieldWithDefault(msg, 2, 0.0),
    throttle: +jspb.Message.getFieldWithDefault(msg, 3, 0.0),
    brake: +jspb.Message.getFieldWithDefault(msg, 4, 0.0),
    drivemode: jspb.Message.getFieldWithDefault(msg, 5, 0),
    speed: +jspb.Message.getFieldWithDefault(msg, 6, 0.0),
    eta: jspb.Message.getFieldWithDefault(msg, 7, 0),
    batterycharge: +jspb.Message.getFieldWithDefault(msg, 8, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ori.telecomms.proto.VehicleStatus}
 */
proto.ori.telecomms.proto.VehicleStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ori.telecomms.proto.VehicleStatus;
  return proto.ori.telecomms.proto.VehicleStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ori.telecomms.proto.VehicleStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ori.telecomms.proto.VehicleStatus}
 */
proto.ori.telecomms.proto.VehicleStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSteering(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setThrottle(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBrake(value);
      break;
    case 5:
      var value = /** @type {!proto.ori.telecomms.proto.VehicleStatus.DriveMode} */ (reader.readEnum());
      msg.setDrivemode(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSpeed(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEta(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBatterycharge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ori.telecomms.proto.VehicleStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ori.telecomms.proto.VehicleStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ori.telecomms.proto.VehicleStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ori.telecomms.proto.VehicleStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSteering();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getThrottle();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getBrake();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getDrivemode();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getEta();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getBatterycharge();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.ori.telecomms.proto.VehicleStatus.DriveMode = {
  UNKNOWN: 0,
  OFF: 1,
  FORWARD: 2,
  REVERSE: 3,
  PARK: 4,
  NEUTRAL: 5
};

/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.ori.telecomms.proto.VehicleStatus.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.ori.telecomms.proto.VehicleStatus.prototype.setUtime = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double steering = 2;
 * @return {number}
 */
proto.ori.telecomms.proto.VehicleStatus.prototype.getSteering = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 2, 0.0));
};


/** @param {number} value */
proto.ori.telecomms.proto.VehicleStatus.prototype.setSteering = function(value) {
  jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double throttle = 3;
 * @return {number}
 */
proto.ori.telecomms.proto.VehicleStatus.prototype.getThrottle = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 3, 0.0));
};


/** @param {number} value */
proto.ori.telecomms.proto.VehicleStatus.prototype.setThrottle = function(value) {
  jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double brake = 4;
 * @return {number}
 */
proto.ori.telecomms.proto.VehicleStatus.prototype.getBrake = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 4, 0.0));
};


/** @param {number} value */
proto.ori.telecomms.proto.VehicleStatus.prototype.setBrake = function(value) {
  jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional DriveMode driveMode = 5;
 * @return {!proto.ori.telecomms.proto.VehicleStatus.DriveMode}
 */
proto.ori.telecomms.proto.VehicleStatus.prototype.getDrivemode = function() {
  return /** @type {!proto.ori.telecomms.proto.VehicleStatus.DriveMode} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {!proto.ori.telecomms.proto.VehicleStatus.DriveMode} value */
proto.ori.telecomms.proto.VehicleStatus.prototype.setDrivemode = function(value) {
  jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional double speed = 6;
 * @return {number}
 */
proto.ori.telecomms.proto.VehicleStatus.prototype.getSpeed = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 6, 0.0));
};


/** @param {number} value */
proto.ori.telecomms.proto.VehicleStatus.prototype.setSpeed = function(value) {
  jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int32 eta = 7;
 * @return {number}
 */
proto.ori.telecomms.proto.VehicleStatus.prototype.getEta = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.ori.telecomms.proto.VehicleStatus.prototype.setEta = function(value) {
  jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional double batteryCharge = 8;
 * @return {number}
 */
proto.ori.telecomms.proto.VehicleStatus.prototype.getBatterycharge = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 8, 0.0));
};


/** @param {number} value */
proto.ori.telecomms.proto.VehicleStatus.prototype.setBatterycharge = function(value) {
  jspb.Message.setProto3FloatField(this, 8, value);
};


goog.object.extend(exports, proto.ori.telecomms.proto);
